import AnalisaBarangJadiRAE from './FormAnalisaBarangJadi';

export default AnalisaBarangJadiRAE;
